export default __webpack_public_path__ + "static/media/vietnam_solar.3eb1ef2a.png";